import { useTimelineContext } from 'dnd-timeline';
import { memo } from 'react';
import { FreeCells } from './FreeCells.js';
import type { ScheduleView } from './dropLogic.js';
import type { ColumnAvailability } from './occupancy.js';

/**
 * 317 (US2, FR-007 to FR-011) — the free-cars row, sticky under the axis: per column, how many of
 * the cars shown are free for the whole of it. Each cell is a button, so the keyboard reaches the
 * list of free cars exactly as hover does. A full column says "0 free" and carries a mark, never
 * colour alone (Constitution V).
 *
 * Memoised on its props: the columns are computed once per schedule response (R6), so a drag never
 * re-renders this row.
 */
export const OccupancyRow = memo(function OccupancyRow({
  columns,
  view,
}: {
  columns: ColumnAvailability[];
  view: ScheduleView;
}) {
  const { sidebarWidth } = useTimelineContext();

  return (
    <div
      data-testid="schedule-occupancy-row"
      className="sticky top-8 z-10 flex h-7 border-b border-hairline bg-surface"
    >
      <div
        style={{ width: sidebarWidth }}
        className="flex shrink-0 items-center border-r border-hairline px-2 text-[11px] font-semibold text-steel"
      >
        Free cars
      </div>
      <div className="relative flex-1">
        <FreeCells columns={columns} view={view} />
      </div>
    </div>
  );
});
